/** Desk objects: short paths under models/DeskSetup/. Set enabled: false to hide. To use old PC/notebook, set pc path to pc.glb and notebook path to notebook.glb. */
export const DESK_OBJECTS = [
    { id: 'desk', path: 'models/DeskSetup/desk.glb', position: [0, -1020, 500], rotation: [0, 275, 0], scale: 3000, enabled: true },
    { id: 'chair', path: 'models/DeskSetup/chair.glb', position: [4000, -2150, 3600], rotation: [0, 150, 0], scale: 3000, enabled: true },
    { id: 'pc', path: 'models/DeskSetup/macbook_pro_14-inch_m5.glb', position: [10, 100, 600], rotation: [0, 0, 0], scale: 5000, enabled: true, stripEmissive: true },
    { id: 'cactus', path: 'models/DeskSetup/cactus.glb', position: [-1400, 60, 0], rotation: [0, 0, 0], scale: 60, enabled: false },
    { id: 'coffee', path: 'models/DeskSetup/coffee.glb', position: [6400, 10600, 700], rotation: [0, 0, 0], scale: 700, enabled: true },
    { id: 'lamp', path: 'models/DeskSetup/lamp.glb', position: [1800, 50, -200], rotation: [-4, -210, 0], scale: 4, enabled: true },
    { id: 'chess', path: 'models/DeskSetup/chess.glb', position: [-1450, 4350, 100], rotation: [0, 120, 0], scale: 20, enabled: true },
    { id: 'pen', path: 'models/DeskSetup/pen.glb', position: [1100, 100, 100], rotation: [0, 0, 0], scale: 4500, enabled: true },
    { id: 'notebook', path: 'models/DeskSetup/apple_pencil__ipad_pro.glb', position: [-400, 450, 200], rotation: [0, 0, 0], scale: 3000, enabled: true },
    { id: 'plant', path: 'models/DeskSetup/plant.glb', position: [-3500, -2200, 600], rotation: [0, 140, 0], scale: 3000, enabled: true },
    { id: 'carpet', path: 'models/DeskSetup/carpet.glb', position: [-500, -2000, 1500], rotation: [0, 90, 0], scale: 4010, enabled: true },
    { id: 'rubiks', path: 'models/DeskSetup/rubiks.glb', position: [-1500, 270, 1000], rotation: [0, 25, 0], scale: 1.5, enabled: true },
    { id: 'boat', path: 'models/DeskSetup/boat.glb', position: [-1000, 100, 700], rotation: [0, 30, 0], scale: 4000, enabled: true },
    { id: 'papers', path: 'models/DeskSetup/papers.glb', position: [-1500, 100, 1000], rotation: [0, 30, 0], scale: 1600, enabled: true },
];
/** Monitor screen (iframe) position, size, and URL. Adjust to align with PC model. */
const productionIframeUrl = typeof __INNER_SITE_URL__ !== 'undefined' && __INNER_SITE_URL__.trim()
    ? __INNER_SITE_URL__.replace(/\/?$/, '/')
    : 'http://localhost:3000/';
export const SCREEN_CONFIG = {
    position: [10, 620, -135],
    rotation: [-20, 0, 0],
    size: { w: 1510, h: 950 },
    iframeUrl: productionIframeUrl,
    iframeUrlDev: 'http://localhost:3000/',
    showBezel: false,
    showOverlayLayers: false,
    borderRadiusTop: 0,
    borderRadiusBottom: 0,
    containerBackground: '#1a1a1e',
    bezelColor: '#e5e5ea',
    iframePadding: 0,
    monitorViewDistance: 1600,
    monitorViewDistanceMobile: 2000,
    /** Mobile horizontal (landscape) screen view: multiply distance by this. Lower = more zoomed in. Edit here to tune. */
    monitorViewMobileLandscapeZoom: 0.45,
    /** Mobile vertical (portrait) screen view: multiply distance by this. Higher = more zoomed out. Edit here to tune. */
    monitorViewMobilePortraitZoom: 1.2,
    monitorZoomAspectScale: 1200,
    monitorPanOffset: [0, 0],
};
export const COFFEE_STEAM_CONFIG = {
    enabled: true,
    position: [1800, 750, 700],
    size: [280, 700],
    color: '#bdbdbd',
};
//#c9c9c9
/** Optional background/room model. Set path to '' to disable. */
export const BACKGROUND_CONFIG = null;
export const LIGHTING_CONFIG = {
    ambient: { color: '#ffffff', intensity: 0.22 },
    directional: {
        color: '#fffef8',
        intensity: 1.0,
        position: [400, 500, 150],
        castShadow: true,
    },
    hemisphere: {
        sky: '#c0d0ff',
        ground: '#303040',
        intensity: 0.3,
        position: [0, 200, 0],
    },
};
export const FLOOR_CONFIG = {
    enabled: false,
    size: [2000, 2000],
    position: [0, -10, 0],
    rotation: [-90, 0, 0],
    color: '#252530',
};
/** Scene background color (hex string). Light white with slight blue tint. */
export const SCENE_BACKGROUND = '#eef2f8';
export const GRID_BACKGROUND_CONFIG = {
    enabled: false,
    baseColor: '#eef2f8',
    lineColor: '#b8c4d8',
    lineOpacity: 0.55,
    floorRows: 6,
    wallColumns: 6,
    floorStrength: 1.2,
    blinkSpeed: 0.4,
    blinkIntensity: 0.08,
    blinkCellSize: 0.15,
    mouseRadiusPx: 140,
    mouseIntensity: 0.5,
};
export const ORGANIC_BACKGROUND_CONFIG = {
    enabled: false,
    baseColor: '#eef2f8',
    blobColor: '#b8c8dc',
    blobCount: 5,
    driftSpeed: 0.2,
    blobRadius: 0.28,
    blobSoftness: 2.0,
    opacity: 0.14,
    mouseRepelRadius: 0.2,
    mouseRepelStrength: 0.7,
};
/** Camera main focus height (Y). Lower = view aims lower (better for shorter Mac). Raise to aim higher. */
export const CAMERA_FOCUS_Y = -1200;
export const DESK_VIEW_CONFIG = {
    position: [0, 1800, 5500],
    focalPoint: [0, CAMERA_FOCUS_Y + 1700, 0],
};
export const IDLE_VIEW_CONFIG = {
    position: [-12000, 7200, 12000],
    focalPoint: [0, CAMERA_FOCUS_Y, 0],
};
export const ORBIT_VIEW_CONFIG = {
    minDistance: 4000,
    maxDistance: 20000,
    position: [-12000, 8000, 12000],
    focalPoint: [-100, CAMERA_FOCUS_Y + 1550, 0],
};
/** Idle orbit rotation speed. 0.00008 = original; 0.00004 = half rotation. */
export const IDLE_ORBIT_SPEED = 0.00004;
/** Idle orbit phase offset (ms). Positive = shift orbit clockwise when viewed from above. */
export const IDLE_ORBIT_PHASE_OFFSET = 6000;
/** Idle orbit horizontal arc. 1 = full 180° swing; 0.5 = 90° swing. */
export const IDLE_ORBIT_X_AMPLITUDE_SCALE = 0.5;
/** Idle orbit vertical bobbing amplitude. Lower = less zoom in/out as it orbits (e.g. 2000). */
export const IDLE_ORBIT_Y_AMPLITUDE = 2000;
/** Mobile breakpoint (px). Width < this = mobile. */
export const MOBILE_BREAKPOINT = 768;
/** On mobile: scale camera distance for idle/desk view. 1 = same as desktop; <1 = closer (less zoomed out). */
export const MOBILE_GENERAL_VIEW_SCALE = 0.88;
/** On mobile portrait desk view: scale camera distance. 1 = same as desktop; <1 = more zoomed in, >1 = more zoomed out. (Screen/monitor view is separate.) */
export const MOBILE_PORTRAIT_DESK_VIEW_SCALE = 2.65;
/** Mobile vertical desk view: [X, Y, Z] added to camera position. Keep [0,0,0] for same angle as desktop. */
export const MOBILE_PORTRAIT_DESK_POSITION_OFFSET = [0, 0, 0];
/** Mobile vertical desk view: [X, Y, Z] added to focal point. [0,0,0] = same look-at as desktop. */
export const MOBILE_PORTRAIT_DESK_FOCAL_OFFSET = [0, 0, 0];
/** Mobile vertical desk view: if true, camera looks at the screen (then only position offset + scale matter). */
export const MOBILE_PORTRAIT_DESK_LOOK_AT_SCREEN = false;
/** Mobile vertical desk view: no extra rotation = same look direction as desktop (0,0). Was PI/2, -PI/2 which made view from the right. */
export const MOBILE_PORTRAIT_DESK_CAMERA_ROTATION_Y = 0;
export const MOBILE_PORTRAIT_DESK_CAMERA_ROTATION_Z = 0;
/** On mobile portrait (idle/full desk): scale camera distance when not using position override. 1 = same as desktop; <1 = zoom in. */
export const MOBILE_PORTRAIT_VIEW_SCALE = 0.78;
/** On mobile portrait (idle): shift camera position right (positive X). Only used when MOBILE_PORTRAIT_IDLE_POSITION is null. */
export const MOBILE_PORTRAIT_IDLE_X_OFFSET = 4500;
/** On mobile portrait (idle): camera center position. ~40° from face-on = view from left side of desk (camera to left of center, negative x). [x, y, z]. Higher z = more zoomed out. Set to null to use orbit + offset + scale instead. */
export const MOBILE_PORTRAIT_IDLE_POSITION = [-14000, 5200, 26500];
/** On mobile portrait (idle): orbit amplitude so the desk slowly turns like other views. X = horizontal swing, Y = vertical bobbing. */
export const MOBILE_PORTRAIT_IDLE_ORBIT_AMPLITUDE_X = 2200;
export const MOBILE_PORTRAIT_IDLE_ORBIT_AMPLITUDE_Y = 450;
/** On mobile landscape: scale camera distance for full desk view.
 * 1 = same as desktop. >1 = more zoomed out. <1 = more zoomed in.
 * Edit this file: portfolio-website/src/Application/World/deskSceneConfig.ts */
export const MOBILE_LANDSCAPE_DESK_VIEW_SCALE = 1.0;
